import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'hg_theme';
const VALID = ['auto', 'light', 'dark'];

function applyTheme(theme) {
  const html = document.documentElement;
  html.classList.remove('light', 'dark');
  if (theme === 'light') html.classList.add('light');
  else if (theme === 'dark') html.classList.add('dark');
}

export function useTheme() {
  const [theme, setThemeState] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return VALID.includes(saved) ? saved : 'auto';
  });

  useEffect(() => {
    applyTheme(theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const setTheme = useCallback((next) => {
    if (VALID.includes(next)) setThemeState(next);
  }, []);

  const cycleTheme = useCallback(() => {
    setThemeState((current) => {
      const idx = VALID.indexOf(current);
      return VALID[(idx + 1) % VALID.length];
    });
  }, []);

  return { theme, setTheme, cycleTheme };
}
